import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TaskTemplateListing, TaskTemplateAddEdit } from './Pages';

export const TaskTemplateRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={TaskTemplateListing} />
        <Route exact path={`${match.path}/AddEdit`} component={TaskTemplateAddEdit} />
    </Fragment>
)